import ApiService from "../api";

type Address = {
  cep: string;
  complemento: string;
  unidade: string;
  logradouro: string;
  erro?: string;
  bairro: string;
  localidade: string;
  uf: string;
  estado: string;
  regiao: string;
  ibge: string;
  gia: string;
  ddd: string;
  siafi: string;
};

export const getCepAPI = (cepRaw: string) => {
  // ViaCEP exige apenas números e 8 dígitos
  const cep = String(cepRaw).replace(/\D/g, "");
  if (cep.length !== 8) {
    return Promise.reject(new Error("invalid_cep_length"));
  }
  return ApiService.HttpGet<Address>({
    route: `https://viacep.com.br/ws/${cep}/json/`,
    token: false,
    external: true,
    noDefautHeaders: true,
  });
};
